import { type ReactNode } from 'react';

import { type AssetCustomFieldValue, type BoardCustomFieldValue } from '@air/api/types';
import { cn } from '@air/utils-tailwind';

import {
  CustomFieldLabel,
  type CustomFieldLabelProps,
} from '~/components/CustomFields/CustomFieldInputLabel/CustomFieldLabel';

export type PanelCustomFieldContainerProps<Field extends BoardCustomFieldValue | AssetCustomFieldValue> = {
  canEditCustomFields: boolean;
  canDeleteCustomFields: boolean;
  children: ReactNode;
  className?: string;
  field: Field;
  onClick?: CustomFieldLabelProps['onClick'];
};

export const PanelCustomFieldContainer = <Field extends BoardCustomFieldValue | AssetCustomFieldValue>({
  canEditCustomFields,
  canDeleteCustomFields,
  children,
  className,
  field,
  onClick,
}: PanelCustomFieldContainerProps<Field>) => {
  return (
    <div className={cn('mb-4 flex w-full flex-col items-start justify-start gap-1', className)}>
      <CustomFieldLabel
        field={field}
        canDeleteCustomFields={canDeleteCustomFields}
        canEditCustomFields={canEditCustomFields}
        onClick={onClick}
      />
      {children}
    </div>
  );
};
